import { getValidBoxes } from '../config/boxConfig';

export const initialState = {
  root: 'A',
  mode: 'minor pentatonic',
  boxModeEnabled: false,
  box: '1',
  currentSystem: 'pentatonic',
  lastFullSystem: 'TNPS',
};

export function fretboardReducer(state, action) {
  switch (action.type) {
    case 'SET_ROOT': {
      return {
        ...state,
        root: action.payload,
      };
    }

    case 'SET_MODE': {
      const isPentatonic = action.payload.includes('pentatonic');
      return {
        ...state,
        mode: action.payload,
        currentSystem: isPentatonic ? 'pentatonic' : state.lastFullSystem,
        box: isPentatonic ? '1' : (state.lastFullSystem === 'CAGED' ? 'C' : '1'),
      };
    }

    case 'SET_BOX': {
      return {
        ...state,
        box: action.payload,
      };
    }

    case 'SET_BOX_MODE': {
      return {
        ...state,
        boxModeEnabled: action.payload,
      };
    }

    case 'SET_SYSTEM': {
      const newSystem = action.payload;
      const isModePentatonic = state.mode.includes('pentatonic');
      const validBoxes = getValidBoxes(state.mode, newSystem);
      const newBox = isModePentatonic ? state.box : validBoxes[0];

      return {
        ...state,
        currentSystem: newSystem,
        lastFullSystem: isModePentatonic ? state.lastFullSystem : newSystem,
        box: newBox,
      };
    }

    default: {
      return state;
    }
  }
}
